/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import axiosInstance from '@/utils/axiosInstance';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { ZodError } from 'zod';

export async function axiosBaseQuery({ url, method, data, params, headers }: AxiosRequestConfig) {
    try {
        const result = await axiosInstance({
            url,
            method,
            data,
            params,
            headers,
        });
        return { data: result.data };
    } catch (e) {
        if (e instanceof AxiosError) {
            return {
                error: {
                    status: e.response?.status,
                    data: e.response?.data || e.message,
                },
            };
        }

        if (e instanceof ZodError) {
            return {
                error: {
                    data: e.errors,
                },
            };
        }

        return {
            error: e,
        };
    }
}
